module.exports = __webpack_public_path__ + "img/giftCertificate1_2.ab5c3208.png";